import { createSlice } from "@reduxjs/toolkit";


export const setPropertyUnitAsync = (propertyUnitInfoPayload) => async (dispatch) => {
  try{
    dispatch(setPropertyUnit(propertyUnitInfoPayload));
    return 'Dispatched successfully';
  }catch (error){
    throw error;
  }
}; 


const propertyUnitSlice = createSlice({
  name: "propertyUnit",
  initialState: null,
  reducers: {
    setPropertyUnit: (state, action) => {
      return action.payload;
    },
  },
});

export const { setPropertyUnit } = propertyUnitSlice.actions;
export default propertyUnitSlice.reducer;